import { App, plugin } from '@inertiajs/inertia-vue';

import PortalVue from 'portal-vue';
import Vue from 'vue';
import VueMeta from 'vue-meta'
import Echo from "laravel-echo"
import Pusher from 'pusher-js';
import VueDatePicker from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import axios from 'axios';
import { Ziggy } from './ziggy';

window.RecordRTC = require('recordrtc');
window.WhammyRecorder = require('recordrtc').WhammyRecorder;

window.Pusher = Pusher;
Vue.config.productionTip = false;
Vue.mixin(require('./Utils/i18n'));
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.datePickerLocale = {
  lang: {
    name: 'ro',
    weekdays: 'duminica_luni_marti_miercuri_joi_vineri_sambata'.split('_'),
    weekdaysShort: 'dum_lun_mar_mie_joi_vin_sam'.split('_'),
    weekStart: 1,
    months: 'ianuarie_februarie_martie_aprile_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort: 'ian_feb_mar_apr_mai_iun_iul_aug_sept_oct_noi_dec'.split('_'),
    formats: {
      LT: 'HH:mm',
      LTS: 'HH:mm:ss',
      L: 'DD/MM/YYYY',
      LL: 'D MMMM YYYY',
      LLL: 'D MMMM YYYY HH:mm',
      LLLL: 'dddd D MMMM YYYY HH:mm',
    },
    ordinal: n => `${n}º`,
    buttonCancel: 'Anulare',
    buttonValidate: 'Ok',
    rangeHeaderText: 'De la %d pana la 13',
  },
};

if (!sessionStorage.getItem('deviceClientId')) {
  sessionStorage.setItem('deviceClientId', Math.random().toString());
}

Vue.mixin({
  methods: {
    isSafari() {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    },
    authUser() {
      let user = {
        id: null,
        role: {
          name: null
        },
        permissions: {
          view_jobs: false,
          create_jobs: false,
          delete_jobs: false,
          view_clients: false,
          view_users: false,
          view_surveys: false,
          view_consent_forms: false,
          view_dealerships: false,
          view_car_makes: false,
          create_consents: false,
          view_settings: false,
        }
      };

      if (this.$page.props.auth.user) {
        user = this.$page.props.auth.user
      }

      return {
        isConsultant() {
          return user.role.name === 'consultant';
        },
        isTechnician() {
          return user.role.name === 'technician';
        },
        isAdmin() {
          return user.role.name === 'admin';
        },
        permissions: user.permissions,
        id: user.id
      }
    },
    route: (...args) => {
      if (args[1]) {
        args[1] = {...Ziggy.defaultParameters, ...args[1]};
      } else {
        args.push(Ziggy.defaultParameters);
      }

      return window.route(...args);
    },

    isUrl(...urls) {
      if (urls[0] === '') {
        return location.pathname.substr(1) === ''
      }

      return urls.filter(url => url.endsWith(location.pathname.substr(0))).length;
    },

    isRoute(routeName) {
      return window.route().current() === routeName;
    },

    error(field, errorBag = 'default') {
      if (!this.$page.props.errors.hasOwnProperty(errorBag)) {
        return null;
      }

      if (this.$page.props.errors[errorBag].hasOwnProperty(field)) {
        return this.$page.props.errors[errorBag][field][0];
      }

      return null;
    },

    validationError(field, errorBag = 'default') {
      if (!this.$page.props.errors.hasOwnProperty(errorBag)) {
        return null;
      }

      if (typeof field === "object") {
        for (let prop in field) {
          if (this.$page.props.errors[errorBag].hasOwnProperty(prop)) {
            return this.$page.props.errors[errorBag][prop][0];
          }
        }
      }

      if (this.$page.props.errors[errorBag].hasOwnProperty(field)) {
        return this.$page.props.errors[errorBag][field][0];
      }

      return null;
    },
  }
});

Vue.use(VueMeta);
Vue.use(plugin);
Vue.use(PortalVue);
Vue.use(VueDatePicker);

let app = document.getElementById('app');
let pageData = JSON.parse(app.dataset.page);

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: '71ce4fc4dd8914413b8f',
  cluster: 'eu',
  forceTLS: true
});

new Vue({
  metaInfo: {
    title: 'Casa Auto',
  },
  mounted() {
    if (pageData.props.auth.user && localStorage.getItem('user') != pageData.props.auth.user.id) {
      localStorage.setItem('user', pageData.props.auth.user.id);
      this.$inertia.reload({preserveScroll: true, preserveState: true});
    }

    window.addEventListener('popstate', () => {
      this.$page.props.loading = true;
      this.$inertia.reload({preserveScroll: true, preserveState: false}).finally(() => this.$page.props.loading = false);
    });
  },
  render: h => h(App, {
    props: {
      initialPage: pageData,
      resolveComponent: name => require(`./Pages/${name}`).default,
      transformProps(props) {
        Ziggy.defaultParameters = {
          dealership: props.dealership_slug,
        };
        return props;
      }
    },
  }),
}).$mount(app);

Object.intersect = function (obj1, obj2) {
  Object.keys(obj1).forEach((key) => {
    if (key in obj2) {
      obj1[key] = obj2[key];
    }
  });
};
